import { IButtonStyles, mergeStyles } from "@fluentui/react";

export const formButtonContainerStyles = mergeStyles([{
    marginTop: '2dvh',
    width: '30dvw',
    height: 'auto',
}]);

export const xxlFormButtonContainerStyles = mergeStyles([{
    marginTop: '4dvh',
    width: '50dvw',
    height: 'auto',
}]);

export const xlFormButtonContainerStyles = mergeStyles([{
    marginTop: '4dvh',
    width: '60dvw',
    height: 'auto',
}]);

export const lgFormButtonContainerStyles = mergeStyles([{
    marginTop: '4dvh',
    width: '60dvw',
    height: 'auto',
}]);

export const mdFormButtonContainerStyles = mergeStyles([{
    marginTop: '4dvh',
    width: '75dvw',
    height: 'auto',
}]);

export const smFormButtonContainerStyles = mergeStyles([{
    marginTop: '6dvh',
    width: '80dvw',
    height: 'auto',
}]);

export const innerTextStyles = mergeStyles([{
    fontSize: '1rem',
    fontWeight: 500,
    fontFamily: 'Nunito',
    textAlign: 'center',
    padding: '2dvh',
}]);

export const sendEmailContainerStyles = mergeStyles([{
    width: '100%',
    height: 'auto',
    gap: '1dvh',
}]);

export const fallbackMsAccountStyles: IButtonStyles = {
    root: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        color: '#2A7DE1',
        fontSize: '.875rem',
        fontWeight: 500,
        fontFamily: 'Nunito',
        paddingTop: '3dvh'
    },
    textContainer: {
        textAlign: 'left',
    },
    icon: {
        color: '#2A7DE1',
    }
}